export class FileExplorerResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<FileSearchRecord>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileExplorerResponse.attributeTypeMap;
    }
    constructor() {
    }
}
